export default function getAudioContext() {
    return new (window.AudioContext || window.webkitAudioContext)()
}